<template>
    <el-tabs v-model="activeName" @tab-click="handleClick" id="classify-tab">
        <el-tab-pane v-for="(item, index) in value" :key="index"
                     :label="item.label"
                     :name="item.name"></el-tab-pane>
        <el-tab-pane v-if="isSelect">
            <el-button size="mini" slot="label" type="primary" @click="select">
                筛选
            </el-button>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
  name: 'classifyTabs',
  props: {
    value: Array,
    isSelect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeName: '0'
    }
  },
  methods: {
    handleClick (tab, value) {
      this.$emit('changeTab', tab, value, this.activeName)
    }
    // select (val, value) {
    //   this.$emit('select')
    // }
  }
}
</script>

<style lang="scss" scoped>
    ::v-deep#classify-tab {
        flex: 1;

        .el-tabs__header {
            margin: 0 !important;
        }

        .el-tabs__item {
            height: 56px;
            line-height: 56px;
            font-size: 14px;
            font-weight: bolder;
        }

        .el-tabs__nav-next, .el-tabs__nav-prev {
            line-height: 56px;
        }

    }
</style>
